import React from 'react'
import { ListingSearchFieldReduxFormWrapper, utils } from '@adc/ui-core'

/* istanbul ignore next */
const field = fieldProps => (
  <ListingSearchFieldReduxFormWrapper compact {...fieldProps} />
)

const { GRAPH_API_FRAGMENT_DEFINITION, GRAPH_API_FRAGMENT_REFERENCE } =
  utils.symbols
field[GRAPH_API_FRAGMENT_DEFINITION] =
  ListingSearchFieldReduxFormWrapper[GRAPH_API_FRAGMENT_DEFINITION]
field[GRAPH_API_FRAGMENT_REFERENCE] =
  ListingSearchFieldReduxFormWrapper[GRAPH_API_FRAGMENT_REFERENCE]

export default field
